// static references so vite replaces them at build time.
// window.__env is populated at runtime by env-config.js (on-prem only).
const VITE_DEFAULTS = {
  VITE_APP_IS_ONPREM: import.meta.env.VITE_APP_IS_ONPREM,
  VITE_APP_IS_ONPREM_DESKTOP: import.meta.env.VITE_APP_IS_ONPREM_DESKTOP,
  VITE_APP_STAGING_ONLY: import.meta.env.VITE_APP_STAGING_ONLY,
  VITE_APP_DEV_MODE: import.meta.env.VITE_APP_DEV_MODE,
  VITE_APP_ROOT_API: import.meta.env.VITE_APP_ROOT_API,
  VITE_APP_BUCKET_BASE_URL: import.meta.env.VITE_APP_BUCKET_BASE_URL,
  VITE_APP_DISABLE_URL_SUBMISSIONS: import.meta.env.VITE_APP_DISABLE_URL_SUBMISSIONS,
  VITE_APP_PREM_USB_MODE: import.meta.env.VITE_APP_PREM_USB_MODE,
  VITE_APP_PREM_AUTH_TOKEN: import.meta.env.VITE_APP_PREM_AUTH_TOKEN,
  VITE_APP_SENTRY_DSN: import.meta.env.VITE_APP_SENTRY_DSN,
  VITE_APP_SENTRY_ENVIRONMENT: import.meta.env.VITE_APP_SENTRY_ENVIRONMENT,
  VITE_APP_HUBSPOT_PORTAL_ID: import.meta.env.VITE_APP_HUBSPOT_PORTAL_ID,
  VITE_APP_HUBSPOT_FORM_ID: import.meta.env.VITE_APP_HUBSPOT_FORM_ID,
  VITE_APP_VERSION: import.meta.env.VITE_APP_VERSION,
  VITE_APP_ALLOW_INDEXING: import.meta.env.VITE_APP_ALLOW_INDEXING,
};

function getEnv(key) {
  if (typeof window !== "undefined" && window.__env && window.__env[key] !== undefined) {
    return window.__env[key];
  }
  return VITE_DEFAULTS[key];
}

// lazy getters so runtime values are always fresh
const config = {};
for (const key of Object.keys(VITE_DEFAULTS)) {
  Object.defineProperty(config, key, {
    get: () => getEnv(key),
    enumerable: true,
  });
}

export default config;
